import { orderBy } from 'lodash';
import { RECEIVED_STATUSES } from '@/constants/manifestStatuses';
import { getItemPalletId } from '@/utilities/manifestPallets';

// Manifest queries select `latest_event` (newest first, limit 1); the order page already has the full
// `tracking_events` list, which upserts strip as read-only, so it is ranked the same way here.
const newestEvent = (item) =>
    item?.latest_event
        ? item.latest_event[0]
        : orderBy(
              item?.tracking_events || [],
              [(event) => (event.event_time ? new Date(event.event_time).getTime() : -Infinity), 'event_id'],
              ['desc', 'desc']
          )[0];

// A unit the app picked off the shelf: no pallet and its newest tracking event is the pick. It was received
// even when it has no received_at (a RETURN received at completion).
export const isPickedStockUnit = (item) =>
    !!item?.inventory_unit && !getItemPalletId(item) && newestEvent(item)?.event_type === 'ITEM_PICKED_FROM_WAREHOUSE';

// A unit that was received, closed or picked and has no received pallet left the shelf; receiving it would
// give a box that is gone a new RECEIVED pallet. Lines with no unit row stay receivable.
export const canMarkReceived = (item) => {
    if (RECEIVED_STATUSES.includes(item?.pallet?.warehouse_status)) return false;
    if (isPickedStockUnit(item)) return false;
    const unit = item?.inventory_unit;
    return !unit || (!unit.closed_at && !unit.received_at);
};
